/**
 * Bundle Checkout Handler
 * Manages bundle product quantities, totals, and checkout for Eir Organics
 */
class BundleCheckout {
    constructor(bundleCard) {
        this.bundleCard = bundleCard;
        this.bundleType = bundleCard.dataset.bundleType;
        this.checkoutBtn = bundleCard.querySelector('[data-bundle-action]');
        this.totalDisplay = bundleCard.querySelector('.total-price');
        this.init();
    }

    init() {
        this.checkoutBtn.addEventListener('click', () => this.handleCheckout());
        this.calculateTotal();
    }

    calculateTotal() {
        const bundleItem = this.bundleCard.querySelector('[data-variant-id]');
        const price = parseFloat(bundleItem.dataset.price);
        let total = 0;

        if (this.bundleType === 'bogo') {
            // Buy 1 Get 1 Free = Pay for 1
            total = price * 1;
        } else if (this.bundleType === 'buy2get2') {
            // Buy 2 Get 2 Free = Pay for 2
            total = price * 2;
        }

        this.totalDisplay.textContent = `$${total.toFixed(2)}`;
    }

    async handleCheckout() {
        const bundleItem = this.bundleCard.querySelector('[data-variant-id]');
        const variantId = bundleItem.dataset.variantId;
        const quantity = parseInt(bundleItem.dataset.bundleQuantity);

        const items = [{
            id: variantId,
            quantity: quantity
        }];

        this.checkoutBtn.disabled = true;
        this.checkoutBtn.textContent = 'Processing...';

        try {
            // Add all items to cart
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items: items })
            });

            // Apply bundle discount and go to checkout
            await this.applyBundleDiscount(quantity);

            window.location.href = '/checkout';
        } catch (error) {
            console.error('Error:', error);
            alert('Error processing order. Please try again.');
            this.checkoutBtn.disabled = false;
            this.checkoutBtn.textContent = this.getButtonText();
        }
    }

    async applyBundleDiscount(quantity) {
        const bundleItem = this.bundleCard.querySelector('[data-variant-id]');
        const price = parseFloat(bundleItem.dataset.price);
        let discountAmount = 0;

        if (this.bundleType === 'bogo') {
            // Discount = price of 1 free item
            discountAmount = price * 1;
        } else if (this.bundleType === 'buy2get2') {
            // Discount = price of 2 free items
            discountAmount = price * 2;
        }

        // Note: You'll need to create discount codes in Shopify admin
        // Or use cart attributes to track the bundle discount
        const cartNote = `Bundle: ${this.bundleType} - Discount: $${discountAmount.toFixed(2)}`;

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                note: cartNote,
                attributes: {
                    'bundle_type': this.bundleType,
                    'bundle_discount': discountAmount.toFixed(2)
                }
            })
        });
    }

    getButtonText() {
        if (this.bundleType === 'bogo') {
            return 'START NOW';
        } else if (this.bundleType === 'buy2get2') {
            return 'START NOW';
        }
        return 'START NOW';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const bundleCards = document.querySelectorAll('[data-bundle-card]');
    bundleCards.forEach(card => new BundleCheckout(card));
});
